module.exports = __webpack_public_path__ + "static/media/president.2c1bd54f.jpeg";